import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function QuoteDialog({ open, onOpenChange, leadId, onSaved }) {
  const [f, setF] = useState({ ref_no: "", amount: "", notes: "" });
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) {
      setF({ ref_no: `SQ-${new Date().getFullYear()}-${String(Date.now()).slice(-5)}`, amount: "", notes: "" });
      setFile(null);
    }
  }, [open]);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/quotations", { lead_id: leadId, ref_no: f.ref_no, amount: Number(f.amount), notes: f.notes });
      if (file) {
        const fd = new FormData();
        fd.append("file", file);
        await api.post(`/quotations/${data.id}/attachments`, fd);
      }
      toast.success("Quotation saved as draft");
      onOpenChange(false);
      onSaved?.();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="quote-dialog">
        <DialogHeader><DialogTitle>New quotation</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Reference no.</Label><Input value={f.ref_no} onChange={(e) => setF({ ...f, ref_no: e.target.value })} data-testid="quote-ref-input" /></div>
            <div className="space-y-1.5"><Label>Amount (PHP)</Label><Input type="number" min="0" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} data-testid="quote-amount-input" /></div>
          </div>
          <div className="space-y-1.5"><Label>Notes</Label><Textarea value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} data-testid="quote-notes-input" /></div>
          <div className="space-y-1.5"><Label>Attachment (PDF / image / XLSX / DOCX, max 10 MB)</Label><Input type="file" accept=".pdf,.png,.jpg,.jpeg,.webp,.xlsx,.docx" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="quote-file-input" /></div>
          <p className="text-xs text-slate-500">Quotations start as Draft. Approval is never automatic — an authorized approver must approve before sending.</p>
        </div>
        <DialogFooter><Button onClick={save} disabled={busy || !f.ref_no.trim() || !(Number(f.amount) > 0)} className="bg-orange-500 hover:bg-orange-600" data-testid="quote-save-button">{busy ? "Saving…" : "Save draft"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
